import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { createProgram } from "api/program.api";
import ProgramForm from "components/program/ProgramForm";
import Toast from "components/Toast";

export default function CreateProgram() {
  const navigate = useNavigate();
  const [alert, setAlert] = useState("");
  const [toast, setToast] = useState({
    open: false,
    title: "",
    message: "",
    type: "success",
  });

  const handleSubmit = async (formData) => {
    try {
      await createProgram(formData);
      setToast({
        open: true,
        title: "Success", 
        message: "Program created successfully",
        type: "success",
      });
      // navigate("/admin/program");
    } catch (err) {
      setAlert(err.response?.data?.message || "Something went wrong");
    }
  };

  return (
    <>
      <Toast
        open={toast.open} 
        title={toast.title}
        message={toast.message}
        type={toast.type}
        duration={1500}
        onClose={() => {
          setToast((prev) => ({ ...prev, open: false }));
          navigate("/admin/program");
        }}
      />  
    <ProgramForm
      onSubmit={handleSubmit}
      onBack={() => navigate("/admin/program")}
      alert={alert}
      setAlert={setAlert}
    />
    </>
  );
}